import { useCallback, useEffect, useRef, useState } from 'react';

export function useVisualFullscreen() {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    let prevH = window.innerHeight;

    const apply = () => setIsFullscreen(!!document.fullscreenElement);

    const detect = () => {
      const h = window.innerHeight;
      if (document.fullscreenElement) {
        setIsFullscreen(true);
        prevH = h;
        return;
      }
      const filled = h >= screen.height - 2;
      const wasFilled = prevH >= screen.height - 2;
      if (filled && !wasFilled) setIsFullscreen(true);
      else if (!filled && wasFilled) setIsFullscreen(false);
      prevH = h;
    };

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'F11') setTimeout(detect, 120);
    };

    document.addEventListener('fullscreenchange', apply);
    window.addEventListener('resize', detect);
    window.addEventListener('keydown', onKeyDown);
    const timer = window.setInterval(detect, 300);
    return () => {
      document.removeEventListener('fullscreenchange', apply);
      window.removeEventListener('resize', detect);
      window.removeEventListener('keydown', onKeyDown);
      window.clearInterval(timer);
    };
  }, []);

  const enter = useCallback(() => {
    document.documentElement.requestFullscreen?.().catch(() => {});
  }, []);

  const exit = useCallback(() => {
    if (document.fullscreenElement) {
      document.exitFullscreen?.().catch(() => {});
    }
  }, []);

  const toggle = useCallback(() => {
    if (document.fullscreenElement) exit();
    else enter();
  }, [enter, exit]);

  return { isFullscreen, enter, exit, toggle };
}